import {
    IonButton,
    IonContent,
    IonIcon,
    IonModal,
} from "@ionic/react";
import React, { useMemo, useState } from "react";
import "./AddTransactionPopOver.css";
import { cardOutline } from "ionicons/icons";
import CurrencyInput from "./CurrencyInput";

const MODAL_BREAKPOINTS = { half: 0.5 } as const;

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (amount: number) => void;
    currentBalance?: number;
};

const AddTransactionPopover: React.FC<Props> = ({
                                                    isOpen,
                                                    onClose,
                                                    onSubmit,
                                                    currentBalance,
                                                }) => {
    const [amount, setAmount] = useState<number | null>(null);

    const addChip = (v: number) => setAmount((prev) => (prev ?? 0) + v);
    const clear = () => setAmount(null);

    const canSubmit = (amount ?? 0) > 0;

    const newBalance = useMemo(() => {
        if (typeof currentBalance !== "number") return undefined;
        return (currentBalance ?? 0) + (amount ?? 0);
    }, [currentBalance, amount]);

    const handleSubmit = () => {
        if (canSubmit) {
            onSubmit(amount as number);
            onClose();
        }
    };

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            className="transaction-modal sheet"
            initialBreakpoint={1}
            breakpoints={[0, MODAL_BREAKPOINTS.half, 1]}
        >
            <IonContent className="modal-content">
                <div className="sheet-handle" />

                <div className="wallet-card">
                    <IonIcon icon={cardOutline} className="wallet-icon" />
                    <div className="wallet-title">
                        <div className="wallet-subtitle">Saldo opwaarderen</div>
                        <div className="wallet-heading">Wallet</div>
                    </div>
                </div>

                <div className="amount-box">
                    <label className="amount-label">Bedrag</label>
                    <div className="amount-row">
                        <div className="amount-euro">€</div>
                        <CurrencyInput
                            onValueChange={setAmount}
                            value={amount ?? 0}
                            placeholder="0,00"
                        />
                    </div>
                </div>

                {typeof currentBalance === "number" && (
                    <div className="summary-grid">
                        <div className="summary-card">
                            <div className="summary-label">Huidig saldo</div>
                            <div className="summary-value">
                                €{currentBalance.toFixed(2).replace(".", ",")}
                            </div>
                        </div>
                        <div className="summary-card">
                            <div className="summary-label">Nieuw saldo</div>
                            <div className="summary-value">
                                €{(newBalance ?? 0).toFixed(2).replace(".", ",")}
                            </div>
                        </div>
                    </div>
                )}

                <div className="actions">
                    <IonButton fill="clear" className="btn-cancel" onClick={onClose}>
                        Annuleren
                    </IonButton>
                    <IonButton
                        className={`submit-button ${canSubmit ? "enabled" : "disabled"}`}
                        onClick={handleSubmit}
                        disabled={!canSubmit}
                    >
                        Geld overmaken
                    </IonButton>
                </div>

                <div className="sheet-bottom-spacer" />
            </IonContent>
        </IonModal>
    );
};

export default AddTransactionPopover;
